import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { KalenderAbwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderAbwesenheit';
import { KalenderByMitarbeiterStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderStation';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

function toKalenderInterval(
  interval: Abwesenheit | ArbeitsbereichStation,
): KalenderAbwesenheit | KalenderByMitarbeiterStation {
  if (interval instanceof Abwesenheit) {
    return new KalenderAbwesenheit({ abwesenheit: interval });
  }

  return new KalenderByMitarbeiterStation({
    station: interval,
    arbeitsbereich: interval.arbeitsbereich,
  });
}

export function mapMitarbeiterKalenderIntervals({
  rotationsplan,
  startOfYear,
  endOfYear,
}: {
  rotationsplan: Rotationsplan;
  startOfYear: dayjs.Dayjs;
  endOfYear: dayjs.Dayjs;
}): {
  id: string;
  hasOverlaps: boolean;
  interval: KalenderAbwesenheit | KalenderByMitarbeiterStation;
}[] {
  const intervals: (Abwesenheit | ArbeitsbereichStation)[] = [
    ...rotationsplan.allStationen,
    ...rotationsplan.abwesenheiten,
  ]
    .filter(
      (interval) =>
        dayjs(interval.von).isSameOrBefore(endOfYear) &&
        dayjs(interval.bis).isSameOrAfter(startOfYear),
    )
    .sort((a, b) => dayjs(a.von).diff(dayjs(b.von), 'day'));

  return intervals.map((interval) => ({
    id: interval.id,
    hasOverlaps: intervals.some(
      (other) =>
        other.id !== interval.id &&
        dayjs(interval.von).isSameOrBefore(dayjs(other.bis)) &&
        dayjs(interval.bis).isSameOrAfter(dayjs(other.von)),
    ),
    interval: toKalenderInterval(interval),
  }));
}
